/**
 * Cómo paga el cliente de una cotización cd-2b: cada mes o un año por adelantado.
 *
 * Los números los calcula la API (`/propuestas/cotizar` devuelve `anual`: total del año, ahorro y
 * comisión inicial con la política del país). Aquí solo se decide qué se muestra; no se calcula
 * ningún precio ni porcentaje en el navegador.
 */

/** El resumen del pago anual, o `null` si la cotización es mensual o la API aún no lo mandó. */
export function resumenAnual(ciclo, anual) {
  if (ciclo !== 'anual' || !anual || !(Number(anual.total) > 0)) return null
  return { total: Number(anual.total), ahorro: Number(anual.ahorro) || 0, comisionInicial: anual.comisionInicial ?? null }
}

/** Las dos formas de pago para el selector. El anual queda deshabilitado mientras no haya precio. */
export function opcionesDeCiclo({ mensual, anual }) {
  const total = Number(anual?.total) > 0 ? Number(anual.total) : null
  const ahorro = Number(anual?.ahorro) || 0
  return [
    { value: 'mensual', titulo: 'Cada mes', monto: Number(mensual) || 0, periodo: ' al mes', deshabilitada: false },
    {
      value: 'anual',
      titulo: 'Un año por adelantado',
      monto: total,
      periodo: ' al año',
      deshabilitada: total == null,
      nota: ahorro > 0 ? (moneda, formato) => `Ahorra ${formato(ahorro, moneda)} frente a pagar 12 meses.` : null,
    },
  ]
}
